import banner from "../../../courses/finanzas.webp";

const modulo7 = {
  courseId: "finanzas-personales",
  id: "modulo-7",
  title: "🧪 MODULE 7: Final Evaluation",
  estimatedDuration: "30–45 minutes",
  format: "Online final exam + optional reflection",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objectives",
      content: [
        "Verify that you understand the key concepts of the course.",
        "Validate that you can apply what you learned in your daily life.",
        "Take the final step to obtain your ZyVerse Professional Certificate.",
      ],
    },
    {
      id: "incluye",
      navLabel: "Evaluation topics",
      title: "✅ What does this evaluation include?",
      content: [
        "📌 Final exam",
        {
          type: "list",
          items: [
            "20 multiple-choice questions",
            "Based on the previous 6 modules",
            "Topics: budgeting, saving, credit, investing, consumption, and habits",
            "Estimated duration: 25–30 minutes",
            "Minimum passing score: 60% correct answers",
          ],
        },
      ],
    },
    {
      id: "examen",
      navLabel: "Final Exam",
      title: "📝 FINAL EXAM",
      questions: [
        {
          id: "q1",
          question:
            "What is the first step to start organizing your personal finances?",
          options: [
            { key: "a", text: "Investing in CETES" },
            { key: "b", text: "Making a budget" },
            { key: "c", text: "Opening a credit card" },
            { key: "d", text: "Buying in cash" },
          ],
          correct: "b",
        },
        {
          id: "q2",
          question:
            "Which of the following statements about budgeting is correct?",
          options: [
            { key: "a", text: "It only works if you earn a lot of money" },
            { key: "b", text: "It helps you plan and control your expenses" },
            { key: "c", text: "It is the same as saving" },
            { key: "d", text: "Only companies use it" },
          ],
          correct: "b",
        },
        {
          id: "q3",
          question: "What are small recurring expenses?",
          options: [
            { key: "a", text: "Large monthly purchases" },
            { key: "b", text: "Small expenses that repeat and add up" },
            { key: "c", text: "Emergency expenses" },
            { key: "d", text: "Borrowed money" },
          ],
          correct: "b",
        },
        {
          id: "q4",
          question: "Which one is an example of a fixed expense?",
          options: [
            { key: "a", text: "Cinema" },
            { key: "b", text: "Coffee" },
            { key: "c", text: "Rent" },
            { key: "d", text: "Snacks" },
          ],
          correct: "c",
        },
        {
          id: "q5",
          question: "What does the letter “M” represent in a SMART goal?",
          options: [
            { key: "a", text: "Measurable" },
            { key: "b", text: "Minimum" },
            { key: "c", text: "Monthly" },
            { key: "d", text: "Monetary" },
          ],
          correct: "a",
        },
        {
          id: "q6",
          question:
            "What is the recommended percentage of available credit usage?",
          options: [
            { key: "a", text: "90%" },
            { key: "b", text: "100%" },
            { key: "c", text: "No more than 30%" },
            { key: "d", text: "10%" },
          ],
          correct: "c",
        },
        {
          id: "q7",
          question: "What is the credit bureau?",
          options: [
            { key: "a", text: "A card company" },
            {
              key: "b",
              text: "An institution that records your financial history",
            },
            { key: "c", text: "A payment app" },
            { key: "d", text: "A digital bank" },
          ],
          correct: "b",
        },
        {
          id: "q8",
          question: "What is a sign of a risky credit offer?",
          options: [
            { key: "a", text: "It requires history" },
            { key: "b", text: "It promises easy money with no requirements" },
            { key: "c", text: "It has a fixed rate" },
            { key: "d", text: "It asks for documents" },
          ],
          correct: "b",
        },
        {
          id: "q9",
          question: "What is compound interest?",
          options: [
            { key: "a", text: "Earning money by inviting friends" },
            { key: "b", text: "Generating interest on previous interest" },
            { key: "c", text: "A type of tax" },
            { key: "d", text: "A payment for using cash" },
          ],
          correct: "b",
        },
        {
          id: "q10",
          question: "Which of these options is a low-risk investment?",
          options: [
            { key: "a", text: "Cryptocurrencies" },
            { key: "b", text: "CETES" },
            { key: "c", text: "Startups" },
            { key: "d", text: "Foreign stock market" },
          ],
          correct: "b",
        },
        {
          id: "q11",
          question: "What does the Law of Risk and Return say?",
          options: [
            { key: "a", text: "Higher return implies higher risk" },
            { key: "b", text: "Only rich people win" },
            { key: "c", text: "Investing is always safe" },
            { key: "d", text: "Risk does not affect return" },
          ],
          correct: "a",
        },
        {
          id: "q12",
          question:
            "According to the Rule of 110, if you are 20 years old, how much could you invest in riskier instruments?",
          options: [
            { key: "a", text: "80%" },
            { key: "b", text: "60%" },
            { key: "c", text: "90%" },
            { key: "d", text: "30%" },
          ],
          correct: "c",
        },
        {
          id: "q13",
          question: "What does responsible consumption mean?",
          options: [
            { key: "a", text: "Only buying eco-friendly products" },
            { key: "b", text: "Spending only in cash" },
            {
              key: "c",
              text: "Buying consciously and aligned with your goals",
            },
            { key: "d", text: "Stopping consumption completely" },
          ],
          correct: "c",
        },
        {
          id: "q14",
          question: "Which technique helps reduce impulsive purchases?",
          options: [
            { key: "a", text: "Free spending" },
            { key: "b", text: "The 72-hour waiting list" },
            { key: "c", text: "Shopping with friends" },
            { key: "d", text: "Using several cards" },
          ],
          correct: "b",
        },
        {
          id: "q15",
          question: "What does the top of Maslow’s pyramid represent?",
          options: [
            { key: "a", text: "Food and transportation" },
            { key: "b", text: "Self-actualization" },
            { key: "c", text: "Financial security" },
            { key: "d", text: "Family and friends" },
          ],
          correct: "b",
        },
        {
          id: "q16",
          question: "What can you do to start saving with purpose?",
          options: [
            { key: "a", text: "Save what is left over" },
            { key: "b", text: "Avoid spending" },
            {
              key: "c",
              text: "Define a SMART goal and set aside a fixed amount",
            },
            { key: "d", text: "Invest everything in crypto" },
          ],
          correct: "c",
        },
        {
          id: "q17",
          question: "What does a treat budget do?",
          options: [
            { key: "a", text: "Eliminates unnecessary expenses" },
            { key: "b", text: "Prevents you from buying things" },
            {
              key: "c",
              text: "Allows you to enjoy without affecting your finances",
            },
            { key: "d", text: "Increases your card limit" },
          ],
          correct: "c",
        },
        {
          id: "q18",
          question: "What tool helps you observe your financial habits?",
          options: [
            { key: "a", text: "Habits tracking sheet" },
            { key: "b", text: "Weather apps" },
            { key: "c", text: "Civil registry" },
            { key: "d", text: "Honor roll" },
          ],
          correct: "a",
        },
        {
          id: "q19",
          question: "What does the ZyVerse professional certificate include?",
          options: [
            { key: "a", text: "Economic bonus" },
            { key: "b", text: "Debit card" },
            { key: "c", text: "Name, date, course, and verification code" },
            { key: "d", text: "Life insurance" },
          ],
          correct: "c",
        },
        {
          id: "q20",
          question: "Which phrase best summarizes the course philosophy?",
          options: [
            { key: "a", text: "“Make money fast.”" },
            {
              key: "b",
              text: "“Making better decisions is more powerful than earning more.”",
            },
            { key: "c", text: "“Buy without fear.”" },
            { key: "d", text: "“Debt is inevitable.”" },
          ],
          correct: "b",
        },
      ],
    },
    {
      id: "reflexion",
      navLabel: "Final Reflection",
      title: "💡 Final Reflection (optional)",
      content: [
        "What did I learn and how will I apply it?",
        "Although it is not mandatory, sending a written or recorded reflection is recommended to enrich your learning process. It can help you integrate the concepts better into your personal life.",
      ],
    },
    {
      id: "frase",
      navLabel: "Closing quote",
      title: "💬 Closing quote",
      content: [
        "“This course ends here, but your financial journey is just beginning.”",
      ],
    },
  ],
};

export default modulo7;
